import React, {Fragment} from "react";
import PaymentControl from "../../../../form/purchase/payment";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return (hidden || []).indexOf("payment") === -1 && <div className="section">
        <div className="section-title">Fizetés</div>
        <PaymentControl
            availableProviders={props.availablePaymentProviders}
            {...props.getFieldProps("payment")}
            name="payment"
            value={props.getValue("payment")}
            label="Fizetési mód"
            saveChanges={ props.setFieldValue }
            providerTheme={props.providerTheme}
        />
    </div>;
}